import { CarouselItem } from '@/components/ui/carousel'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import type { SelfAssessedLevel } from '@/types/learner-portal'

const ABILITY_LEVELS: SelfAssessedLevel[] = ['A0', 'A1', 'A2', 'B1', 'B2', 'C1']

export default function EnglishAbilityScreen() {
  const { t } = useTranslation()
  const { self_assessed_english_level, setEnglishLevel } = useNeedsAnalysis()

  const handleEnglishLevelChange = (level: SelfAssessedLevel) => {
    setEnglishLevel(level)
  }

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='english-ability-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.englishAbility.title')}
          </h3>
          <p className='text-xs text-gray-600 sm:text-sm'>{t('needsAnalysis.englishAbility.subtitle')}</p>
        </div>

        <div className='max-h-[calc(90vh-260px)] space-y-2 overflow-y-auto pr-1 sm:max-h-[320px] sm:space-y-3 sm:pr-2'>
          <RadioGroup
            aria-labelledby='english-ability-heading'
            value={self_assessed_english_level || undefined}
            onValueChange={(val) => handleEnglishLevelChange(val as SelfAssessedLevel)}
            className='space-y-2 sm:space-y-3'
          >
            {ABILITY_LEVELS.map((level) => (
              <Label
                key={level}
                htmlFor={level}
                className='flex cursor-pointer items-start space-x-2 rounded-lg border border-gray-200 p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-4'
              >
                <RadioGroupItem value={level} id={level} className='mt-0.5 sm:mt-1' />
                <div className='flex-1'>
                  <div className='text-sm font-medium sm:text-base'>
                    {t(`needsAnalysis.englishAbility.levels.${level}`)}
                  </div>
                </div>
              </Label>
            ))}
          </RadioGroup>
        </div>
      </div>
    </CarouselItem>
  )
}
